<!-- <p>captcha-page works!</p> -->
<div class="container">
  <mat-card class="form-card" appearance="outlined">
    <mat-card-title>Verify you are human</mat-card-title>
    <!-- <mat-card-subtitle>
      Time left: <strong>{{ countdown }}</strong> seconds
    </mat-card-subtitle> -->

    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="captcha-box">
          <span class="captcha-code">{{ captchaValue }}</span>
          <mat-form-field appearance="fill" class="captcha-input">
            <mat-label>Enter the code above</mat-label>
            <input
              matInput
              formControlName="captchaInput"
              autocomplete="off"
              maxlength="6"
              spellcheck="false"
            />
            <mat-error *ngIf="form.controls['captchaInput'].hasError('required')">
              Answer is required
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="captchaError" class="captcha-error">{{ captchaError }}</div>

        <button mat-raised-button color="primary" class="full-width" type="submit">
          Validate
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
